import { Button } from '@mui/material';
import React from 'react';
import { makeStyles } from 'tss-react/mui';

import { typography13MediumStyle } from 'src/legacy/components/Text';
import BaseTypography from 'src/legacy/components/Text/BaseTypography';
import { BlackHeadings, GraySmall, WebLink } from 'src/theme/colors';

export interface PageCalloutProps {
  title: string;
  description?: string;
  link?: string;
  linkText?: string;
  actionButtonRenderer?: () => React.ReactNode;
}

const useStyles = makeStyles()((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'baseline',
    maxWidth: '502px',
  },
  title: {
    color: BlackHeadings,
  },
  description: {
    textAlign: 'left',
    color: GraySmall,
    marginTop: theme.spacing(1.5),
  },
  linkButton: {
    marginTop: theme.spacing(1.5),
    ...typography13MediumStyle,
    color: WebLink,
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },
  actionButtonWrapper: {
    marginTop: theme.spacing(4.25),
  },
}));

export const PageCallout: React.FC<PageCalloutProps> = ({
  title,
  description,
  link,
  linkText,
  children,
  actionButtonRenderer,
}) => {
  const { classes } = useStyles();

  return (
    <div className={classes.root}>
      {children}
      <BaseTypography fontType="24Medium" className={classes.title}>
        {title}
      </BaseTypography>
      {description && (
        <BaseTypography fontType="15Regular" className={classes.description}>
          {description}
        </BaseTypography>
      )}
      {link && linkText && (
        <Button className={classes.linkButton} href={link} target="_blank">
          {linkText}
        </Button>
      )}
      {actionButtonRenderer && (
        <div className={classes.actionButtonWrapper}>
          {actionButtonRenderer()}
        </div>
      )}
    </div>
  );
};
